import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_SURVEYS } from '@/api/endpoints';
import { SURVEY_RESULTS_QUERY_KEY } from '@/api/queryKeys';
import { toSurveyResults } from '@/pages/Mail/surveys';
import type { SurveyResults, SurveyResultsResponse } from '@/types/survey';
import { unwrapAxiosResponse } from '@/utils/axios';
import { joinPath } from '@/utils/global';

export const useSurveyResults = (surveyId: string, isEnabled: boolean) =>
  useQuery<SurveyResults>({
    queryKey: [...SURVEY_RESULTS_QUERY_KEY, surveyId],
    enabled: isEnabled,
    queryFn: () =>
      apiClient
        .get<SurveyResultsResponse>(
          `${joinPath(API_SURVEYS, surveyId)}/results`,
        )
        .then(unwrapAxiosResponse)
        .then(toSurveyResults),
  });
